import { Search, SlidersHorizontal } from 'lucide-react';
import { useEffect, useState } from 'react';
import { BottomSheet } from '@/shared/components';
import { useMediaQuery } from '@/shared/hooks/useMediaQuery';
import { isFiltered } from '../components/bookingsListSearch';
import { BookingsFilterControls, type FilterControlsProps } from './BookingsFilterControls';

interface Props extends FilterControlsProps {
  onQueryChange: (next: string) => void;
}

/**
 * Suche und Filter über der Liste (Board „Buchungen“), der Zustand lebt in der URL. Am Handy
 * bleibt die Suche sichtbar, der Rest liegt hinter „Filter“ in einem Blatt (Board „BuchungenHandy“).
 */
export function BookingsToolbar(props: Props) {
  const { query, onQueryChange, canSeeGuests, filters } = props;
  const phone = useMediaQuery('(max-width: 767px)');
  const [sheet, setSheet] = useState(false);
  // Lokaler Puffer plus Entprellung: sonst schriebe jeder Tastendruck die URL und löste eine
  // Abfrage aus. Änderungen von außen (Zurück-Taste, geteilter Link) ziehen den Puffer nach.
  const [draft, setDraft] = useState(query);
  useEffect(() => setDraft(query), [query]);
  useEffect(() => {
    if (draft === query) return;
    const id = window.setTimeout(() => onQueryChange(draft), 300);
    return () => window.clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draft]);
  const active = isFiltered({ ...filters, status: 'all' }, '') || filters.showPast;
  return (
    <section
      aria-label="Suche und Filter"
      className="rounded-tile shadow-float flex flex-wrap items-center gap-2 bg-white p-3"
    >
      <label className="bg-paper rounded-pill flex h-[46px] min-w-0 flex-[1_1_180px] items-center gap-2 px-4">
        <Search size={16} aria-hidden className="text-ink-soft" />
        <input
          type="search"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          placeholder={canSeeGuests ? 'Gast oder Buchungsnummer' : 'Buchungsnummer'}
          aria-label="Suche"
          className="min-w-0 flex-1 bg-transparent text-sm outline-none"
        />
      </label>
      {phone ? (
        <>
          <button
            type="button"
            onClick={() => setSheet(true)}
            className="border-hairline rounded-pill flex h-[46px] items-center gap-2 border bg-white px-4 text-[13px] font-semibold"
          >
            <SlidersHorizontal size={16} aria-hidden />
            Filter{active ? ' · aktiv' : ''}
          </button>
          <BottomSheet open={sheet} onOpenChange={setSheet} title="Filter und Sortierung">
            <div className="flex flex-col items-stretch gap-2 pb-2">
              <BookingsFilterControls {...props} />
            </div>
          </BottomSheet>
        </>
      ) : (
        <BookingsFilterControls {...props} />
      )}
    </section>
  );
}
